import { createFileRoute, redirect } from '@tanstack/react-router'
import { AdjustmentsScreen } from '@/features/inventory-stock/adjustments-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/adjustments')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'stock_adjustment.create')) throw redirect({ to: '/' })
  },
  component: AdjustmentsScreen,
})
